<template>
  <div>
    <div class="banner-container">
      <div class="banner-overlay">
        <div class="container h-100">
          <div class="row h-100">
            <div class="col-lg-5 logo-wrapper">
              <!--<h1 class="banner-heading d-lg-none">
                Ashfield Brickwork
              </h1>-->
              <img
                class="d-lg-block banner-logo"
                src="~@/assets/images/main_logo.png"
                alt="Ashfield Brickwork Ltd Logo"
                style="width: 300px;margin-left:-40px;"
              />
              <hr />
              <p class="banner-content">
                Providing a range of services to meet all your brickwork needs
              </p>
              <router-link to="/contact-us/" class="btn btn-lg banner-link">Get in Touch</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row triangle">
        <div class="col-lg-6"></div>
        <div class="col-lg-6">
          <div class="image-partial">
            <div class="img-cover"></div>
          </div>
        </div>
      </div>
    </div>

    <div id="about-us" class="about-us">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <h2 class="about-us-title">About Us</h2>
            <hr />
            <p>
              <strong>
                We are a family run business, consisting of 3 generations, with over 50 years combined experience in the
                construction industry. Based in South Norfolk, we provide the whole of Norfolk and Suffolk with our bricklaying
                expertise. Whether it is domestic or commercial, we cover all aspects of bricklaying, From new builds, to
                extensions, Garden walls to footings. You ask, we deliver.
              </strong>
            </p>
            <p>
              Customer service & satisfaction is paramount and is at the forefront of everything we do, we will be on hand to
              guide you through every step of the way, from quotation, right through to project completion.
            </p>
            <router-link to="/portfolio/" class="btn">View our Work</router-link>
          </div>
          <div class="col-lg-6 mt-5 mt-lg-0">
            <img class="about-us-img" src="~@/assets/images/portfolio/img_0431.jpg" alt="Project image" />
          </div>
        </div>
      </div>
    </div>

    <div id="our-services" class="our-services">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="our-services-title">Our Services</h2>
            <hr />
          </div>
          <div class="service-card col-md-6 col-lg-4">
            <img class="service-card-img" src="~@/assets/images/new_build.jpeg" alt="New builds image" />
            <div class="service-card-content">
              <h3 class="service-card-title">New Builds</h3>
              <p class="service-card-description">
                Our wealth of knowledge and experience enables us to build you your dream home from scratch.
              </p>
            </div>
          </div>
          <div class="service-card mt-5 mt-md-0 col-md-6 col-lg-4">
            <img class="service-card-img" src="~@/assets/images/portfolio/img_0434.jpg" alt="Extensions image" />
            <div class="service-card-content">
              <h3 class="service-card-title">Extensions</h3>
              <p class="service-card-description">
                Whether it's a front or rear porch, garage/workshop or a single/double storey extension, we can fulfil all your needs.
              </p>
            </div>
          </div>
          <div class="service-card mt-5 mt-lg-0 col-lg-4">
            <img class="service-card-img" src="~@/assets/images/garden-wall.jpg" alt="Garden wall image" />
            <div class="service-card-content card-3-content">
              <h3 class="service-card-title">Garden Walls</h3>
              <p class="service-card-description">
                From boundary walls to retaining walls, feature walls to raised flower beds, we're able to build them all.
              </p>
            </div>
          </div>
          <div class="service-card mt-5 mt-lg-0 col-lg-4">
            <img class="service-card-img" src="~@/assets/images/footings.jpg" alt="Footings image" />
            <div class="service-card-content card-3-content">
              <h3 class="service-card-title">Footings</h3>
              <p class="service-card-description">
                Footings/foundations are one of the most important parts of the project. We ensure foundations are laid to the correct standard.
              </p>
            </div>
          </div>
          <div class="service-card mt-5 mt-lg-0 col-lg-4">
            <img class="service-card-img" src="~@/assets/images/portfolio/351328d9_001a_40d4_80a6_f433cb2d09ad.jpg" alt="Patios image" />
            <div class="service-card-content card-3-content">
              <h3 class="service-card-title">Patios</h3>
              <p class="service-card-description">
                Whether you're looking to use porcelain, natural stone or concrete slabs, we have experience using them all.
              </p>
            </div>
          </div>
          <div class="service-card mt-5 mt-lg-0 col-lg-4">
            <img class="service-card-img" src="~@/assets/images/groundworks.jpg" alt="Groundworks image" />
            <div class="service-card-content card-3-content">
              <h3 class="service-card-title">Groundworks</h3>
              <p class="service-card-description">
                We're able to carry out work in the ground, as well as above it. From oversites to drainage and soakaways.
              </p>
            </div>
          </div>
          <div class="service-card mt-5 mt-lg-0 col-lg-4">
            <img class="service-card-img" src="~@/assets/images/repairs-alterations.jpg" alt="Repairs and alterations image" />
            <div class="service-card-content card-3-content">
              <h3 class="service-card-title">Repairs & Alterations</h3>
              <p class="service-card-description">
                Internal & external wall alterations, RSJ installation and window & door alterations to modify your home.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div id="testimonials" class="testimonials">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="testimonials-title">Testimonials</h2>
            <hr />
          </div>
          <div class="col-12">
            <vue-slick-carousel class="slick" v-bind="settings">
              <div class="testimonials-single">
                <div class="testimonials-single-content">
                  <div class="quote-open">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"
                      />
                    </svg>
                  </div>
                  <p class="testimonials-single-content-body">
                    Vestibulum venenatis euismod tellus, vitae tincidunt mauris
                    sollicitudin lobortis. Pellentesque at enim eu mi iaculis
                    auctor. Ut blandit viverra nisi at interdum. Fusce
                    pellentesque odio et lectus tempus, et porta neque semper.
                  </p>
                  <p class="testimonials-single-content-author">
                    - Client Name
                  </p>
                  <div class="quote-close">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M9.983 3v7.391c0 5.704-3.731 9.57-8.983 10.609l-.995-2.151c2.432-.917 3.995-3.638 3.995-5.849h-4v-10h9.983zm14.017 0v7.391c0 5.704-3.748 9.571-9 10.609l-.996-2.151c2.433-.917 3.996-3.638 3.996-5.849h-3.983v-10h9.983z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div class="testimonials-single">
                <div class="testimonials-single-content">
                  <div class="quote-open">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"
                      />
                    </svg>
                  </div>
                  <p class="testimonials-single-content-body">
                    Vestibulum venenatis euismod tellus, vitae tincidunt mauris
                    sollicitudin lobortis. Pellentesque at enim eu mi iaculis
                    auctor. Ut blandit viverra nisi at interdum. Fusce
                    pellentesque odio et lectus tempus, et porta neque semper.
                  </p>
                  <p class="testimonials-single-content-author">
                    - Client Name
                  </p>
                  <div class="quote-close">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M9.983 3v7.391c0 5.704-3.731 9.57-8.983 10.609l-.995-2.151c2.432-.917 3.995-3.638 3.995-5.849h-4v-10h9.983zm14.017 0v7.391c0 5.704-3.748 9.571-9 10.609l-.996-2.151c2.433-.917 3.996-3.638 3.996-5.849h-3.983v-10h9.983z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div class="testimonials-single">
                <div class="testimonials-single-content">
                  <div class="quote-open">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"
                      />
                    </svg>
                  </div>
                  <p class="testimonials-single-content-body">
                    Vestibulum venenatis euismod tellus, vitae tincidunt mauris
                    sollicitudin lobortis. Pellentesque at enim eu mi iaculis
                    auctor. Ut blandit viverra nisi at interdum. Fusce
                    pellentesque odio et lectus tempus, et porta neque semper.
                  </p>
                  <p class="testimonials-single-content-author">
                    - Client Name
                  </p>
                  <div class="quote-close">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M9.983 3v7.391c0 5.704-3.731 9.57-8.983 10.609l-.995-2.151c2.432-.917 3.995-3.638 3.995-5.849h-4v-10h9.983zm14.017 0v7.391c0 5.704-3.748 9.571-9 10.609l-.996-2.151c2.433-.917 3.996-3.638 3.996-5.849h-3.983v-10h9.983z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </vue-slick-carousel>
          </div>
        </div>
      </div>
    </div> -->

    <!--<div id="accred-logos" class="accred-logos">
      <div class="container">
        <div class="row">
          <div class="col-6 col-md accred-logo">
            <img src="~@/assets/images/nic_mcs_logo.png" alt="NIC MCS Logo" />
          </div>
          <div class="col-6 col-md accred-logo">
            <img src="~@/assets/images/solar_award.png" alt="Solar Award Logo" />
          </div>
        </div>
      </div>
    </div>-->

    <div id="cta-banner" class="cta-banner">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-xl-3 cta-banner-wrapper">
            <h2 class="cta-banner-title">
              Get In Touch
            </h2>
          </div>
          <div class="col-lg-8 col-xl-6 cta-banner-wrapper">
            <p class="cta-banner-content">
              For your free no obligation quote, get in touch today
            </p>
          </div>
          <div class="col-lg-4 col-xl-3 cta-banner-wrapper">
            <router-link to="/contact-us/" class="mt-4 mt-lg-0 btn cta-banner-btn">
              Contact Us
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  name: 'home',
  components: {
    VueSlickCarousel
  },
  data() {
    return {
      settings: {
        dots: true,
        autoplay: true,
        'autoplay-speed': 15000,
        dotsClass: 'slick-dots',
        edgeFriction: 0.35,
        draggable: true,
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only if required -->
<style lang="scss">
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

/****************************
    BANNER
*****************************/
.banner-container {
  background-color: $primary;
  position: relative;

  .triangle {
    overflow: hidden;
  }

  .banner-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    color: $white;
    padding-top: 0;
    z-index: 2;
    overflow: hidden;

    .logo-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      @media (min-width: $md-breakpoint) {
        align-items: flex-start;
      }

      .btn {
        background-color: $primary-dark;
    &:hover {
      background-color: $white;
      color: $primary;
    }
      }
    }

    @media (max-width: $md-breakpoint) {
      background-color: rgba(0, 0, 0, 0.7);
      .banner-logo {
        margin-left: 0 !important;
      }
    }

    @media (max-width: $md-breakpoint) {
      text-align: center;
    }

    .banner-heading {
      color: $white;
      font-size: 60px !important;
      text-transform: capitalize;
      font-weight: bold;
      margin-top: -10px;
      margin-bottom: 20px;

      @media (max-width: 992px) {
        font-size: 50px !important;
        margin-top: 50px;
      }

      @media (max-width: $md-breakpoint) {
        text-align: center;
        margin-top: 0;
      }

      @media (min-width: $lg-breakpoint) {
        font-size: 65px !important;
      }
    }

    hr {
      width: 180px;
      margin: 0;
      margin-bottom: 45px;
      margin-left: auto;
      border-top: 4px solid $primary-dark;
      text-align: center;
      margin-left: 0;
    }

    .banner-content {
      font-weight: 400;
      font-size: 20px;
      margin-bottom: 45px;

      @media (max-width: $md-breakpoint) {
        font-size: 18px;
      }
    }
  }

  >.row {
    margin: 0;

    @media (min-width: $md-breakpoint) {

      :last-child::after,
      :last-child::before {
        content: "";
        display: block;
        position: absolute;
        left: -104px;
        width: 0;
        height: 0;
        border-style: solid;
      }

      // controls the color of the triangle
      *:last-child::after {
        top: -10px;
        border-color: transparent transparent transparent $primary;
        border-bottom-width: 360px;
        border-top-width: 360px;
        border-left: 260px solid $primary;
        left: -164px;
      }

      // controls the white border
      *:last-child::before {
        top: -10px; //0
        border-color: transparent transparent transparent $primary-dark;
        border-bottom-width: 360px;
        border-top-width: 360px;
        border-left: 260px solid $primary-dark;
        left: -160px;
      }
    }

    >* {
      padding: 0;
      position: relative;

      .image-partial {
        margin-left: -160px;

        .img-cover {
          background-image: url("../../assets/images/new_build.jpeg");
          height: 700px;
          display: block;
          background-repeat: no-repeat;
          background-position: left center;
          background-size: cover;
        }
      }
    }
  }
}

/****************************
    ABOUT US
*****************************/
.about-us {
  padding: 64px 0;

  &-img {
    border-radius: 0.3rem;
    border: 3px solid $primary;
    width: 100%;
    height: 100%;
    max-width: 555px;
    max-height: 450px;
    object-fit: cover;
    vertical-align: baseline;
  }

  strong {
    font-size: 16px;
  }

  &-title {
    font-size: 40px;
  }
}

/****************************
    ACCRED LOGOS
*****************************/
.accred-logos {
  padding: 64px 0;

  .accred-logo {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 125px;
      width: 100%;
      object-fit: contain;
    }
  }
}

/****************************
    SERVICES
*****************************/
.our-services {
  padding: 64px 0;
  background-color: $secondary;

  .row {
    row-gap: 30px;
  }

  &-title {
    font-size: 40px;
    color: $white;
  }

  .service-card {
    &-img {
      height: 255px;
      width: 100%;
      object-fit: cover;
      border-radius: 10px 10px 0 0;
    }

    &-content {
      padding: 30px 40px 30px 40px;
      background-color: $primary;
      color: $white;
      text-align: center;
      border-radius: 0 0 10px 10px;
      position: relative;

      @media (max-width: $sm-breakpoint) {
        padding: 60px 25px 25px 25px;
      }

      @media (min-width: $sm-md-breakpoint) {
        height: 240px;
      }

      @media (min-width: $lg-breakpoint) {
        height: 210px;
      }
    }

    .card-3-content {
      @media (min-width: $sm-md-breakpoint) {
        height: auto;
      }

      @media (min-width: $md-breakpoint) {
        height: 240px;
      }

      @media (min-width: $lg-breakpoint) {
        height: 210px;
      }
    }

    &-icon {
      &-wrapper {
        width: 90px;
        height: 90px;
        background-color: $primary-dark;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: -45px;
        left: calc(50% - 45px);
      }
    }

    &-title {
      font-size: 30px;
      font-weight: bold;
    }

    &-description {
      font-size: 16px;
      margin: 0;
    }

    &:last-child {
      @media (max-width: $md-breakpoint) and (min-width: $sm-md-breakpoint) {
        margin-top: 30px !important;
      }
    }
  }
}

/****************************
    TESTINMONIALS
*****************************/
.testimonials {
  padding: 64px 0 34px;

  &-title {
    font-size: 40px;
  }

  &-single {
    padding: 0 15px;
    margin: 0 -15px;

    &-content {
      cursor: move;
      /* fallback if grab cursor is unsupported */
      cursor: grab;
      cursor: -moz-grab;
      cursor: -webkit-grab;

      &:active {
        cursor: grabbing;
        cursor: -moz-grabbing;
        cursor: -webkit-grabbing;
      }

      .quote-open,
      .quote-close {
        position: relative;
        width: 36px;
        height: 37px;

        svg {
          position: absolute;
          fill: #99a5b7;
          transform: scale(1.5);
        }
      }

      .quote-open {
        svg {
          left: 7px;
          bottom: 10px;
        }
      }

      .quote-close {
        float: right;

        svg {
          right: -18px;
          bottom: 90px;

          @media (max-width: $md-breakpoint) {
            bottom: 70px;
          }

          @media (max-width: $sm-breakpoint) {
            bottom: 65px;
          }
        }
      }

      &-body {
        font-style: italic;
        font-size: 22px;
        margin-bottom: 15px;
      }

      &-author {
        font-weight: 600;
        font-size: 20px;
        color: #969696;
      }
    }
  }

  .slick-dots {
    bottom: 35px;

    li {
      width: 11px;
      height: 11px;

      button {
        width: 10px;
        height: 10px;
        border-radius: 100%;
        background-color: $white;
        border: 1px solid #939598;

        &::before {
          content: "";
          width: 0px;
          height: 0px;
        }
      }

      &.slick-active {
        button {
          background-color: $primary;
          border: 1px solid $primary;
        }
      }
    }
  }
}

/****************************
    GET IN TOUCH CTA
*****************************/
.cta-banner {
  background-color: $primary;
  padding: 30px 0;

  &-wrapper {
    display: flex;
    align-items: center;

    &:last-child {
      justify-content: flex-end;

      @media (max-width: $lg-breakpoint) {
        justify-content: center;
      }

      @media (max-width: $md-breakpoint) {
        justify-content: flex-start;
      }
    }
  }

  &-title {
    font-size: 40px;
    font-weight: 500;
    color: $white;
  }

  &-content {
    margin: 0;
    font-size: 18px;
    color: $white;
  }

  &-btn {
    background-color: $primary-dark;
    &:hover {
      background-color: $white;
      color: $primary;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue